module.exports = __webpack_public_path__ + "static/media/TBP.ca48b03c.png";